import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useConfigMC } from '~/store/Query/api';

const Metatags = (props) => {
  const { data } = useConfigMC();
  const [description, setDescription] = useState('');
  const [keywords, setKeywords] = useState('');

  useEffect(() => {
    if (data?.ok && data.body.seo) {
      const seo = data.body.seo.find(item => item.path === window.location.pathname);
      if (seo) {
        setDescription(seo.description);
        setKeywords(seo.keywords);
      }
    }
  }, [data]);

  return (
    <Helmet title={`${props.name} | Tienda Claro ${process.env.NEXT_PUBLIC_COUNTRY}`}>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
    </Helmet>
  );
};

export default Metatags;
